/* eslint-disable */
const Fetch_CROSS_SELL = "Fetch_CROSS_SELL";

const initialState = [];

export const fetchCrossSell = (payload) => ({
  type: Fetch_CROSS_SELL,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Fetch_CROSS_SELL:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
